export default function some(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;
  for (const value of values) {
    if (test(value, ++index, values)) {
      return true;
    }
  }
  return false;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/some.js
// module id = 431
// module chunks = 0